import { createContext } from 'react';

import { Tkv2ReferenceBarUserInterface } from './types.ts';

export const Tkv2ControllerReferenceBarContext =
  createContext<Tkv2ReferenceBarUserInterface | null>(null);
